import { Text as BaseText, View } from 'react-native';
import styled from 'styled-components/native';

import colors from './colors';
import fonts from './fonts';

export const Text = styled(BaseText)`
  font-family: ${fonts.body};
  font-size: 16px;
  color: ${colors.text};
  line-height: 24px;
`;

export const Title = styled(BaseText)`
  font-family: ${fonts.heading};
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: -0.5px;
  color: ${colors.text};
  margin-bottom: 8px;
`;

export const Subtitle = styled(BaseText)`
  font-family: ${fonts.heading};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${colors.text};
  margin-vertical: 16px;
`;

export const Hint = styled(BaseText)`
  font-family: ${fonts.body};
  font-size: 14px;
  font-style: italic;
  color: ${colors.textMuted};
  line-height: 20px;
`;

export const Setting = styled(View)`
  flex-direction: row;
  gap: 12px;
  margin-bottom: 8px;
  align-items: center;
`;

export const SettingLabel = styled(Text)`
  min-width: 200px;
  font-size: 15px;
`;
